import Modal from "../../../UI/Modal/Modal";
import React, { useEffect, useMemo, useState } from "react";
import { Grid, Typography } from "@mui/material";
import InputSearchLine from "../../../UI/Input/InputSearchLine";
import { fnLocalizeFilter } from "../../../../services/localize.service";
import CustomTable from "../../../UI/CustomTable";
import { useGlobalContext } from "../../../../services/context.service";
import { filterObject } from "../../../../utils/methods";
import { cardAPI } from "../../../../services/cardAPI.service";
import { getColumns } from "./card.columns";
import { initialAccount, ITransferAccount } from "../interface";
import { holderAPI } from "../../../../services/holderAPI.service";
import { IRow } from "../../../UI/CustomTable/components/Rows/Rows";


interface IModalFilterAccount {
	isShow: boolean;
	holderId: number;

	handleApplyAccount ( account: ITransferAccount ): void;

	handleClose (): void;
}

export default function ModalFilterAccount ( {
	                                             isShow,
	                                             holderId,
	                                             handleApplyAccount,
	                                             handleClose
                                             }: IModalFilterAccount ) {
	/* Получаем языковую локаль */
	const { locale } = useGlobalContext();

	/* Строка поиска по всем полям таблицы */
	const [ searchStr, setSearchStr ] = useState( '' );
	const [ selectedAccount, setSelectedAccount ] = useState<ITransferAccount>( initialAccount );

	const [ getListCard, { data: dataCards = { cards: [] }, isLoading } ] = cardAPI.useLazyFetchCardsByHolderQuery();
	const [ getHolderAccount, { data: dataAccounts = { accounts: [] } } ] = holderAPI.useLazyFetchAccountsClientQuery();

	useEffect( () => {
		getListCard( { locale, holderId } );
		getHolderAccount( { locale, holderId } )
	}, [] );

	const handleBtnOk = () => {
		selectedAccount.accountId && handleApplyAccount( selectedAccount );
		handleClose();
	};

	/* Фильтр по столбцам таблицы  */
	const rows = useMemo( () => {
		let count = 10;

		const emptyAccounts = dataAccounts.accounts.filter( acc => acc.numbersActiveCards === 0 ).map( a => ( {
			...a,
			accountRemark: a.remark
		} ) );

		let filteredArr = [ ...dataCards.cards, ...emptyAccounts ];

		filteredArr = filterObject( {
			arr: filteredArr,
			fields: [ 'accountId', 'accountRemark', 'lastName', 'firstName', 'mobile', 'cardId' ],
			searchStr
		} );

		return { arr: filteredArr, count };
	}, [ dataCards, dataAccounts, searchStr ] );

	/* Заполняем табличные заголовки */
	const columns = useMemo( () => {
		return getColumns( { locale } );
	}, [ locale ] );

	const handleClickRow = ( row: IRow ) => {

		const totalBalance = dataAccounts.accounts.filter( account => account.accountId === row.accountId )[ 0 ].totalBalanceWithoutOverdraft;

		setSelectedAccount( {
			accountId: row.accountId,
			accountRemark: row.accountRemark,
			totalBalance: totalBalance
		} )
	}


	return (
		<Modal
			handleBtnOk={ handleBtnOk }
			isOpen={ isShow }
			handleBtnCancel={ handleClose }
			disabled={ !selectedAccount.accountId }

		>
			<Grid item sx={ {
				minWidth: '700px',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between'
			} }>
				<Grid sx={ { marginBottom: '2rem' } } display={ 'flex' } alignItems={ 'center' }
				      justifyContent={ 'space-between' }>
					<InputSearchLine
						placeholder={ fnLocalizeFilter( locale, '_lang.module.common.title.titleSearchStr' ) }
						onChange={ ( e: React.ChangeEvent<HTMLInputElement> ) => {
							setSearchStr( e.currentTarget.value );
						} }
						style={ { borderRadius: "5px" } }
					/>
					<Typography>{ fnLocalizeFilter( locale, '_lang.module.common.title.titleSelected' ) }: { selectedAccount.accountId || ' - ' }</Typography>
				</Grid>
				<Grid>
					{
						<CustomTable
							rows={ rows.arr }
							columns={ columns }
							isLoading={ isLoading }
							labelEmptyRows={ fnLocalizeFilter( locale, '_lang.module.common.table.emptyRows' ) }
							isSimple
							onClick={ handleClickRow }
						/>
					}
				</Grid>
			</Grid>
		</Modal>

	)
}
